/* unplugin-vue-components disabled */import { render } from "./SystemInfo.vue?vue&type=template&id=2cf70928&ts=true"
import script from "./SystemInfo.vue?vue&type=script&lang=ts"
export * from "./SystemInfo.vue?vue&type=script&lang=ts"

import "./SystemInfo.vue?vue&type=style&index=0&id=2cf70928&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__